import React, { Fragment, useEffect, useState } from 'react';
import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    Typography,
} from '@mui/material';
import AutoCompleteField from '../../components/general/fields/autoCompleteField';
import FieldText from '../../components/general/fields/fieldText';
import { asyncGetIdentification } from '../../../services/params.service';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { IParam } from '../../../shared/types/param';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const VideoAtention = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [identifications, setIdentifications] = useState<IParam[]>([]);

    const getReCaptcha = async () => {
        try {
            if (executeRecaptcha) {
                const localToken = await executeRecaptcha('someAction');
                return localToken;
            }
        } catch (error) {
            console.error('Error al obtener reCAPTCHA:', error);
            return null;
        }
    };

    const getIdentifications = async () =>
        setIdentifications(await asyncGetIdentification());

    useEffect(() => {
        getIdentifications();
    }, []);

    const formik = useFormik({
        initialValues: {
            type_identification: '',
            name: '',
            surname: '',
            email: '',
            identification: '',
            cell: '',
            acceptPolicy: false,
        },
        validationSchema: Yup.object({
            type_identification: Yup.string().required(
                'El tipo de identificación es obligatorio'
            ),
            identification: Yup.string().required(
                'La identificación es obligatoria'
            ),
            name: Yup.string()
                .required('El nombre es obligatorio')
                .matches(/^[A-Za-z]+$/, 'El nombre solo puede contener letras')
                .test(
                    'NoNumbers',
                    'El nombre no puede contener números',
                    (value) => !/\d/.test(value)
                ),
            surname: Yup.string()
                .required('El apellido es obligatorio')
                .matches(
                    /^[A-Za-z]+$/,
                    'El apellido solo puede contener letras'
                )
                .test(
                    'NoNumbers',
                    'El apellido no puede contener números',
                    (value) => !/\d/.test(value)
                ),
            email: Yup.string()
                .email('El correo es inválido')
                .required('El correo es obligatorio')
                .test('Validate Email', 'El correo es inválido', (value) => {
                    const re =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(value).toLowerCase());
                }),
            cell: Yup.string()
                .matches(
                    /^[0-9]*$/,
                    'El número de celular solo puede contener números'
                )
                .required('El número de celular es obligatorio'),
            acceptPolicy: Yup.boolean()
                .oneOf(
                    [true],
                    'Debe aceptar la política de privacidad y uso de datos personales'
                )
                .required(
                    'Debe aceptar la política de privacidad y uso de datos personales'
                ),
        }),
        onSubmit: async (formChat) => {
            const captcha = (await getReCaptcha()) || '';
            console.log(captcha);
            console.log(formChat);
        },
    });

    return (
        <Box sx={{ width: '100%', maxWidth: 1500, margin: '0 auto' }}>
            <div className="container-icetex-form">
                <div className="container icetex-form">
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="icetex-title-form">
                                <Typography variant="h2">
                                    Video Atención
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                    <div className="icetex-container-form">
                        <Box sx={{ width: '100%' }}>
                            <div className="icetex-wecallyou-containter">
                                <Fragment>
                                    <Box mt={2} mb={2}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Tipo de Identificación:
                                                    </label>
                                                </Box>
                                                <AutoCompleteField
                                                    data={identifications}
                                                    size="small"
                                                    label="Selecciona tu Tipo de Identificacion"
                                                    name="type_identification"
                                                    touched={
                                                        formik.touched
                                                            .type_identification
                                                    }
                                                    errors={
                                                        formik.errors
                                                            .type_identification
                                                    }
                                                    value={
                                                        formik.values
                                                            .type_identification
                                                    }
                                                    onChangeValue={(value) =>
                                                        formik.setFieldValue(
                                                            'type_identification',
                                                            value
                                                        )
                                                    }
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Número de documento:
                                                    </label>
                                                </Box>
                                                <FieldText
                                                    label="Identificacion"
                                                    name="identification"
                                                    type="number"
                                                    size="small"
                                                    touched={
                                                        formik.touched
                                                            .identification
                                                    }
                                                    errors={
                                                        formik.errors
                                                            .identification
                                                    }
                                                    value={
                                                        formik.values
                                                            .identification
                                                    }
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Nombres:
                                                    </label>
                                                </Box>
                                                <FieldText
                                                    label="Nombre"
                                                    name="name"
                                                    size="small"
                                                    touched={
                                                        formik.touched.name
                                                    }
                                                    errors={formik.errors.name}
                                                    value={formik.values.name}
                                                    onChange={(event) => {
                                                        const { value } =
                                                            event.target;
                                                        if (
                                                            /^[A-Za-z]*$/.test(
                                                                value
                                                            )
                                                        ) {
                                                            formik.handleChange(
                                                                event
                                                            );
                                                        }
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Apellidos:
                                                    </label>
                                                </Box>
                                                <FieldText
                                                    label="Apellido"
                                                    name="surname"
                                                    size="small"
                                                    touched={
                                                        formik.touched.surname
                                                    }
                                                    errors={
                                                        formik.errors.surname
                                                    }
                                                    value={
                                                        formik.values.surname
                                                    }
                                                    onChange={(event) => {
                                                        const { value } =
                                                            event.target;
                                                        if (
                                                            /^[A-Za-z]*$/.test(
                                                                value
                                                            )
                                                        ) {
                                                            formik.handleChange(
                                                                event
                                                            );
                                                        }
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Correo:
                                                    </label>
                                                </Box>
                                                <FieldText
                                                    label="Correo Usuario"
                                                    name="email"
                                                    size="small"
                                                    touched={
                                                        formik.touched.email
                                                    }
                                                    errors={formik.errors.email}
                                                    value={formik.values.email}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Teléfono fijo o celular:
                                                    </label>
                                                </Box>
                                                <FieldText
                                                    label="Teléfono fijo o celular"
                                                    name="cell"
                                                    type="tel"
                                                    size="small"
                                                    touched={
                                                        formik.touched.cell
                                                    }
                                                    errors={formik.errors.cell}
                                                    value={formik.values.cell}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            className="checkbox_boot"
                                                            id="policy"
                                                            name="aceptoPolitica"
                                                            checked={
                                                                formik.values
                                                                    .acceptPolicy
                                                            }
                                                            onChange={() => {
                                                                formik.setFieldValue(
                                                                    'acceptPolicy',
                                                                    !formik
                                                                        .values
                                                                        .acceptPolicy
                                                                );
                                                            }}
                                                            onBlur={
                                                                formik.handleBlur
                                                            }
                                                        />
                                                    }
                                                    label={
                                                        <a
                                                            target="_blank"
                                                            href="https://web.icetex.gov.co/atencion-al-ciudadano/politica-de-tratamiento-de-datos-personales"
                                                        >
                                                            Acepto la política
                                                            de privacidad y uso
                                                            de datos personales
                                                        </a>
                                                    }
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sx={{ textAlign: 'center' }}
                                            >
                                                <Button
                                                    type="submit"
                                                    className="icetex-btn-primary"
                                                    onClick={() =>
                                                        formik.handleSubmit
                                                    }
                                                >
                                                    Iniciar Videollamada
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Fragment>
                            </div>
                        </Box>
                    </div>
                </div>
            </div>
        </Box>
    );
};

export default VideoAtention;
